import { useQuery } from '@tanstack/react-query';

import { QueryKey } from '@/Config/api/queryKey';
import { CreditTopupOffer } from '@/Domain/api/Subscription/dto/CreditTopup.dto';

export const useCreditTopupOffer = () => {
  const { data, isLoading } = useQuery<CreditTopupOffer>({
    queryKey: [QueryKey.subscription.creditTopup],
  });

  return { offer: data, isEligible: !!data?.eligible, isLoading };
};
